export interface PackWizard {
    id: number;
    description: string;
    serviceIDs: string[];
    joinCitation: boolean;
    isChecked: boolean;
    familyId: string;
    familySourceId: string;
}

/**
 * Factoría que crea un Pack para el asistente de pedir cita con los datos recogidos por la API
 */
export function packWizardFactory(param, index) {
    return {
        id: index,
        description: param.Description,
        serviceIDs: param.ZoneList.split(','),
        joinCitation: param.ProductJoinCitation === '-1',
        isChecked: false,
        familyId: param.FamilyId,
        familySourceId: param.FamilySourceID
    };
}
